export enum ERouterName {
    ELEMENT = 'element',
    PROJECT = 'project',
    HOME = 'home',
    TSA = 'tsa',
    LAYER = 'layer',
    MEDIA = 'media',
    WAYLINE = 'wayline',
    LIVESTREAM = 'livestream',
    LIVING = 'living',
    WORKSPACE = 'workspace',
    MEMBERS = 'members',
    DEVICES = 'devices',
    TASK = 'task',
    CREATE_PLAN = 'create-plan',
    SELECT_PLAN = 'select-plan',
    FIRMWARES = 'firmwares',
    FLIGHT_AREA = 'flight-area',
    OSD_HISTORY = 'osd-history',

    PILOT = 'pilot-login',
    PILOT_HOME = 'pilot-home',
    PILOT_MEDIA = 'pilot-media',
    PILOT_LIVESHARE = 'pilot-liveshare',
    PILOT_BIND = 'pilot-bind'
}

export enum EStorageKey {
    LANG_CODE = 'DJI_CREATE_VITE_H5_APP:lang_code',
    TEST_TOOLS_POSITION_STORAGE_KEY = 'DJI_CREATE_VITE_H5_APP:test_tools_position',
    SESSION_ID = 'DJI_CREATE_VITE_H5_APP:sess'
}

export enum EStatusValue {
    CONNECTED = 'Connected',
    DISCONNECT = 'Disconnect',
    LIVING = 'Living'
}

export enum ELiveStatusValue {
    DISCONNECT,
    CONNECTED,
    LIVING
}

export enum EComponentName {
    Thing = 'thing',
    Liveshare = 'liveshare',
    Api = 'api',
    Ws = 'ws',
    Map = 'map',
    Tsa = 'tsa',
    Media = 'media',
    Mission = 'mission'
}

export enum ELocalStorageKey {
    Username = 'username',
    WorkspaceId = 'workspace_id',
    Token = 'x-auth-token',
    PlatformName = 'platform_name',
    WorkspaceName = 'workspace_name',
    WorkspaceDesc = 'workspace_desc',
    Flag = 'flag',
    UserId = 'user_id',
    Device = 'device',
    GatewayOnline = 'gateway_online',
}

export enum EPhotoType {
    Original = 0,
    Preview = 1,
    Unknown = -1
}

export enum EDownloadOwner {
    Mine = 0,
    Others = 1,
    Unknown = -1
}

export enum EUserType {
    Web = 1,
    Pilot = 2,
}

export enum EBizCode {
    GatewayOsd = 'gateway_osd',
    DeviceOsd = 'device_osd',
    DockOsd = 'dock_osd',
    MapElementCreate = 'map_element_create',
    MapElementUpdate = 'map_element_update',
    MapElementDelete = 'map_element_delete',
    DeviceOnline = 'device_online',
    DeviceOffline = 'device_offline',
    DeviceHms = 'device_hms',

    // 스테이션 임무
    FlightTaskProgress = 'flighttask_progress', // 스테이션 임무 실행 진행률
    FlightTaskMediaProgress = 'file_upload_callback', // 스테이션 임무 미디어 업로드 진행률
    FlightTaskMediaHighestPriority = 'highest_priority_upload_flighttask_media', // 스테이션 임무 미디어 우선순위 보고

    // 장치 제어 명령
    DeviceReboot = 'device_reboot', // 스테이션 재부팅
    DroneOpen = 'drone_open', // 드론 전원 켜기
    DroneClose = 'drone_close', // 드론 전원 끄기
    DeviceFormat = 'device_format', // 스테이션 데이터 초기화
    DroneFormat = 'drone_format', // 드론 데이터 초기화
    CoverOpen = 'cover_open', // 덮개 열기
    CoverClose = 'cover_close', // 덮개 닫기
    PutterOpen = 'putter_open', // 푸시로드 전개
    PutterClose = 'putter_close', // 푸시로드 수축
    ChargeOpen = 'charge_open', // 충전 시작
    ChargeClose = 'charge_close', // 충전 중지

    // 장치 업데이트
    DeviceUpgrade = 'ota_progress', // 장치 펌웨어 업데이트 진행률

    // 장치 로그
    DeviceLogUploadProgress = 'fileupload_progress', // 장치 로그 업로드 진행률

    // 비행 제어 메시지
    ControlSourceChange = 'control_source_change', // 제어권 업데이트
    FlyToPointProgress = 'fly_to_point_progress', // 목표 지점 비행 진행률
    TakeoffToPointProgress = 'takeoff_to_point_progress', // 원클릭 이륙 진행률
    JoystickInvalidNotify = 'joystick_invalid_notify', // 장치 DRC 모드 종료 알림
    DrcStatusNotify = 'drc_status_notify', // 비행 제어 모드 상태

    // custom flight area
    FlightAreasSyncProgress = 'flight_areas_sync_progress',
    FlightAreasDroneLocation = 'flight_areas_drone_location',
    FlightAreasUpdate = 'flight_areas_update',
}

export enum EDeviceTypeName {
    Aircraft = 0,
    Gateway = 2,
    Dock = 3,
}

export enum EHmsLevel {
    NOTICE,
    CAUTION,
    WARN,
}
